import { useMachineUtilizationWidget } from "common/pages/fleetV2/machine/protein/views/MachineHealth/components/MachineUtilizationWidget/hooks/useMachineUtilizationWidget";
import { MachineUsageCardContainer } from "./MachineUsageCard.elements";
import { useDateRange } from "components";
import { getDurationInMs } from "common/pages/fleetV2/machine/protein/views/MachineHealth/components/MachineUtilizationWidget/utils";

interface Machine {
    name: string;
    id: string;
}

interface MachineUsageCardProps {
    lineRunningTarget: number | undefined;
    machines: Machine[];
    maxHours?: number;
}

const MachineUsageCard = ({lineRunningTarget, machines, maxHours}: MachineUsageCardProps) => {

    const { dateRange } = useDateRange();

    const machineUtilizationDataList = machines.map(machine => {
        return {
            machine,
            ...useMachineUtilizationWidget({ machineId: machine.id }),
        };
    });

    const machineRunningDurations = machineUtilizationDataList.map(({ machine, data }) => ({
        name: machine.name,
        runningDuration:
            data?.runningDuration !== undefined
                ? `${Number(getDurationInMs('running', data.runningDuration, dateRange.startTime, dateRange.endTime))}h`
                : '-',
    }));

    return (
        <MachineUsageCardContainer className="card">
            <div className="card-header">
                <div className="label-group">
                    <div className="label">--- Target</div>
                    <div className="value">{lineRunningTarget ? `${lineRunningTarget}h` : '-'}</div>
                </div>
                <div className="label-group">
                    <div className="checkbox"></div>
                    <div className="label">Max hours</div>
                    <div className="value">{maxHours ? `${maxHours}h` : '-'}</div>
                </div>
            </div>
            <div className="machine-list">
                {machineRunningDurations.map(({ name, runningDuration }) => (
                    <div className="machine-row" key={name}>
                    <span className="machine-name">{name}</span>
                    <span className="machine-hours">{runningDuration}</span>
                    </div>
                ))}
            </div>
        </MachineUsageCardContainer>
    );
};

export default MachineUsageCard;